import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../helper/Api";
import Toastify from "../helper/Toastify";

const initialState = {
    isLoading: false,
    isResending: false,
    updateProfileData: {},
    updatePasswordData: {},
    errorMsg: "",
    isError: false
}

export const AffiliateupdateProfile = createAsyncThunk('AffiliateupdateProfile', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.AffiliateupdateProfile(body);
        dispatch(setLoading(true))

        console.log(data,"data!--------");
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setUpdateProfile(body))
                Toastify.success("Profile Updated successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)
export const AffiliateupdatePassword = createAsyncThunk('AffiliateupdatePassword', async (body, { rejectWithValue, dispatch }) => {
    try {
        
        const { data, status } = await api.AffiliateupdatePassword(body);
        dispatch(setLoading(true))
        
        if (status === 200) {
                dispatch(setLoading(false))
                dispatch(setUpdatePassword(body))
                Toastify.success("Password Updated successfully");
        }
        return data.data
    } catch (err) {
        dispatch(setLoading(false))
        Toastify.error(err.response.data.message);
        return rejectWithValue(err.response.data.message || "'Something went wrong. Please try again later.'")
    }
}
)


export const affiliatesettingsSlice = createSlice({
    name: "affiliatesettings",
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setUpdateProfile: (state, action) => {
            state.updateProfileData = action.payload
        },
        setUpdatePassword: (state, action) => {
            state.updatePasswordData = action.payload
        },
        
    },
    
})

export const { setLoading,setUpdateProfile,setUpdatePassword } = affiliatesettingsSlice.actions

export default affiliatesettingsSlice.reducer;